var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex items-center h-full",
      class: {
        "absolute inset-0 justify-end": _vm.$ui.mobile,
        "relative justify-start flex-grow mr-4 z-20": _vm.$ui.desktop
      },
      attrs: { role: "search" }
    },
    [
      _c("BaseTransition", { attrs: { animation: "fade" } }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.$search.open,
                expression: "!$search.open"
              }
            ],
            staticClass:
              "\n                flex items-center p-4\n                rounded text-black hover:bg-gray-300\n                transform\n                desktop:text-gray-600\n                desktop:absolute desktop:-translate-y-1/2 desktop:top-1/2 desktop:py-2\n            ",
            attrs: {
              type: "button",
              title:
                'You can also press "/" to start searching within your collection!'
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.$search.start()
              }
            }
          },
          [
            _c("BaseIcon", {
              staticClass:
                "w-6 h-6 p-1 desktop:w-4 desktop:h-4 desktop:p-0 desktop:mr-2",
              attrs: { name: "search" }
            }),
            _c("span", { staticClass: "text-sm hidden desktop:block" }, [
              _vm._v('Press "s" to start searching')
            ])
          ],
          1
        )
      ]),
      _c("BaseTransition", { attrs: { animations: "fade resize-width" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$search.open,
                expression: "$search.open"
              }
            ],
            staticClass: "absolute w-full desktop:mt-0 desktop:relative",
            staticStyle: { "min-width": "58px" }
          },
          [
            _c("input", {
              ref: "search-input",
              staticClass:
                "\n                    block w-full py-2 pr-4 pl-10\n                    bg-white shadow rounded-lg appearance-none border border-primary-200 focus:border-primary-300\n                ",
              attrs: {
                type: "text",
                autocomplete: "off",
                spellcheck: "false",
                "aria-label": "Search box",
                placeholder: "Search movies"
              },
              domProps: { value: _vm.$search.query },
              on: {
                input: function($event) {
                  return _vm.$search.update($event.target.value)
                },
                keydown: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape"
                      ])
                    ) {
                      return null
                    }
                    return _vm.$search.stop()
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.$search.submit()
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "up", 38, $event.key, [
                        "Up",
                        "ArrowUp"
                      ])
                    ) {
                      return null
                    }
                    return _vm.$search.highlightResultAbove()
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "down", 40, $event.key, [
                        "Down",
                        "ArrowDown"
                      ])
                    ) {
                      return null
                    }
                    return _vm.$search.highlightResultBelow()
                  }
                ]
              }
            }),
            _c(
              "div",
              {
                staticClass:
                  "pointer-events-none absolute inset-y-0 left-0 pl-4 flex items-center"
              },
              [
                _c("BaseIcon", {
                  staticClass: "w-4 h-4 pointer-events-none text-gray-600",
                  attrs: { name: "search" }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c("AppHeaderSearchResults", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.$search.open && _vm.$search.query.length > 0,
            expression: "$search.open && $search.query.length > 0"
          }
        ]
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }